import CallError from '../../utils/CallError';
import Settings from '../../utils/Settings';
import fetchAndSetInSessionStorage from '../../utils/fetchAndSetInSessionStorage';

export const settings = new Settings();

/**
 * Get the most popular CC tags
 * @return {Promise<{name: string, key: string}[]>}
 */
export default async (_params, signal = null) => {
  return await fetchAndSetInSessionStorage('uxpCategories', async () => {
    let content;
    const response = await fetch(settings.endpoint, {
      signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    content = await response.text();
    try {
      content = JSON.parse(content);
    } catch (e) {
      // response is not json
    }

    if (!response.ok) {
      throw new CallError('http', content, response.status, { message: response.statusText });
    } else {
      content = content?.categories?.map(({ name, id }) => ({ name, key: id }));
    }
    return content;
  });
};
